import { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import { ProductTypes } from '../../../interfaces/products.interface'
import * as yup from 'yup'
import * as Styled from '../../../components/UI/StyledForm'
import { StyledDivider } from '../../../components/UI/StyledDivider'
import { StyledButton } from '../../../components/UI/StyledButton'
import FormSpinner from '../../../components/UI/Spinners/FormSpinner'

interface Props {
  product?: ProductTypes
  onSubmit: (values: { image: string }) => void
  isFormLoading: boolean
}

const ProductForm = ({ product, onSubmit, isFormLoading }: Props) => {
  const [imagePreview, setImagePreview] = useState<string>(product ? product.product_photo : '')
  const [prevImage, setPrevImage] = useState<string | File>('')

  const initialValues = {
    image: product ? product.product_photo : '',
  }

  const validationSchema = yup.object({
    image: yup.string().required(),
  })

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  })

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      URL.revokeObjectURL(imagePreview)
    },
    [imagePreview]
  )

  return (
    <>
      <div style={{ marginTop: '30px' }}>
        <Styled.InputWrapper news>
          <Styled.Label news>Id:</Styled.Label>
          <p>{product?.productid || '-'}</p>
        </Styled.InputWrapper>
        <Styled.InputWrapper news>
          <Styled.Label news>Κωδικός:</Styled.Label>
          <p>{product?.code || '-'}</p>
        </Styled.InputWrapper>
        <Styled.InputWrapper news>
          <Styled.Label news>Όνομα:</Styled.Label>
          <p>{product?.name || '-'}</p>
        </Styled.InputWrapper>
      </div>

      <Styled.Form onSubmit={formik.handleSubmit} news>
        <Styled.InputWrapper news>
          <Styled.Label
            news
            htmlFor='image'
            error={formik.touched.image && formik.errors.image ? true : false}
          >
            Εικόνα:
          </Styled.Label>
          <Styled.FileMsgWrapper>
            <Styled.FileWrapper>
              <Styled.Label file htmlFor='image'>
                Αναζήτηση Αρχείου...
              </Styled.Label>
            </Styled.FileWrapper>
            {!imagePreview && (
              <Styled.FileMsg error={formik.touched.image && formik.errors.image ? true : false}>
                Δεν έχετε επιλέξει εικόνα
              </Styled.FileMsg>
            )}
          </Styled.FileMsgWrapper>
          <Styled.InputFile
            type='file'
            id='image'
            name='image'
            accept='image/*'
            onChange={event => {
              if (event.target.files !== null) {
                formik.setFieldValue(
                  'image',
                  event.target.files[0] === undefined ? prevImage : event.target.files[0]
                )

                if (event.target.files[0] !== undefined) {
                  setPrevImage(event.target.files[0])
                  setImagePreview(URL.createObjectURL(event.target.files[0]))
                }
              }
            }}
            onBlur={formik.handleBlur}
          />
        </Styled.InputWrapper>
        <StyledDivider />
        <Styled.FormBottomWrapper>
          <Styled.ImagePreviewWrapper>
            {imagePreview && <Styled.ImagePreview src={imagePreview} />}
          </Styled.ImagePreviewWrapper>
          <Styled.FormButtonWrapper>
            <StyledButton publish type='submit'>
              {isFormLoading ? <FormSpinner /> : 'Αποθήκευση'}
            </StyledButton>
          </Styled.FormButtonWrapper>
        </Styled.FormBottomWrapper>
      </Styled.Form>
    </>
  )
}

export default ProductForm
